document.addEventListener('DOMContentLoaded', () => {
	const accordins = document.querySelectorAll('.faq__wrapper .accordion summary');

	accordins.forEach((v, i) => {
		v.addEventListener('click', () => {
			accordins.forEach((w) => {
				if(v !== w) {
					w.toggleAttribute('aria-expanded');
					w.parentNode.removeAttribute('open')
				}
			}) 
		})
	})
});